"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.money_PricingModelValidation = void 0;
class money_PricingModelValidation {
    static isValid(entity) {
        // Validate entity.pricing_model_money_PricingModel_json for existence and correct type.
        if (entity.pricing_model_money_PricingModel_json == undefined)
            return false;
        if (typeof entity.pricing_model_money_PricingModel_json !== "string")
            return false;
        return true;
    }
}
exports.money_PricingModelValidation = money_PricingModelValidation;
